import { FontAwesomeIcon } from "../../../CommonComponents/AssetsHelper";

export default function FailedPaymentStatus({closeFailedPaymentStrip}){
return <div className="paymentfailedStrip">
            <div className="ex-reconnetwrapper justify-content-center w-100 px-3">
                <div className="ex-conntectinfo text-center">
                    <i className="fas fa-exclamation-circle"></i> Looks like we couldn't process your payment. Update your billing details for an uninterrupted experience.
                </div>
                <a href="transactions#productSubscriptions" className="ms-3 btn btn-link p-0 text-gradient text-capitalize">Update Details &gt;&gt;</a>
            </div>
            <div className="nb_close nb_close_hide_show" onClick={()=>closeFailedPaymentStrip()}>
                <FontAwesomeIcon type={'regular'} icon={'xmark'} iconClass={'fs-6'} />
            </div>
        </div>
}


